import { IPOConfigFromBackend } from '@app/@types/po/poConfig'

const extractPoNumbers = (items: Array<IPOConfigFromBackend>):
  Array<number> => items.map((item: IPOConfigFromBackend) => Number(item.number))

export default extractPoNumbers
